// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2IhYo","approved":"Status_approved__1YUtD","rejected":"Status_rejected__1wxVy","expired":"Status_expired__NTkvq","label":"Status_label__gP3uR"};